import React from 'react';
import { useLocation } from 'react-router-dom';
import { FaArrowUp } from "react-icons/fa";

const ScrollToTopButton = () => {
  const location = useLocation();

  // Mientras haya un modal abierto encima (perfil de modelo, preview de
  // media, etc. — todos pushean su ruta con state.background), este botón
  // de la página de fondo queda semi-tapado por el overlay oscuro del modal
  // en vez de desaparecer, así que se oculta acá.
  if (location.state?.background) {
    return null;
  }

  const scrollToTop = () => {
    // Lista de IDs de contenedores scrollables
    const scrollableIds = ['x'];

    let scrolled = false;

    // Intentar encontrar y desplazar al primer contenedor válido por ID
    for (const id of scrollableIds) {
      const element = document.getElementById(id);

      if (element) {
        element.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        scrolled = true;
        break;
      }
    }

    // Fallback al desplazamiento de la ventana si no se encontró ningún contenedor
    if (!scrolled) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-5 right-5 bg-rose-500 text-white rounded-full p-4 shadow-sm hover:bg-rose-600 transition-all duration-200 z-10 cursor-pointer"
      aria-label="Scroll to top"
    >
      <FaArrowUp className="text-2xl" />
    </button>
  );
};

export default ScrollToTopButton;
